var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row justify-content-center align-items-center" },
    [
      _c(
        "div",
        {
          staticClass:
            "col-lg-7 p-0 text-lg-left text-center text-white d-flex flex-column align-items-lg-start align-items-center",
          class: { "order-2": _vm.direction === "left" },
        },
        [
          _c("h2", { staticClass: "bold p-0 text-white" }, [
            _vm._v("\n      " + _vm._s(_vm.header) + "\n    "),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "mt-4 p-0" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.subtitle) } }),
          ]),
          _vm._v(" "),
          _vm.buttonText
            ? _c(
                "div",
                {
                  staticClass: "row no-gutters w-100 text-lg-left text-center",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "clickable col-xxl-6 col-xl-8 col-12 mt-4 btn btn-white tutorial-link",
                      on: { click: _vm.handleRedirect },
                    },
                    [_vm._v(_vm._s(_vm.buttonText))]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-lg-block col-3 d-none text-left" }, [
        _c("img", {
          staticClass: "img-fluid",
          staticStyle: { "max-height": "250px" },
          attrs: { src: _vm.imgSrc, alt: "" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }